import ResponsiveComponent from '../../ResponsiveComponent';
import SkuCardDesktop from './desktop/SkuCardDesktop';
import SkuCardMobile from './mobile/SkuCardMobile';
import { getReactKey } from '@/utilites/react/react.util';
import { SkuCardsResponsiveProps } from '@/types/props/components';

export default function SkuCardsResponsive({
  skus,
  windowWidth,
}: SkuCardsResponsiveProps) {
  return (
    <ResponsiveComponent
      windowWidth={windowWidth}
      MobileComponent={skus.map((sku, index) => (
        <SkuCardMobile
          key={getReactKey.skuCarousel.mobile(sku, index)}
          sku={sku}
        />
      ))}
      DesktopComponent={skus.map((sku, index) => (
        <SkuCardDesktop
          key={getReactKey.skuCarousel.desktop(sku, index)}
          sku={sku}
        />
      ))}
    />
  );
}
